/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { orderReviewCreateRequestSchema } from "./orderReviewCreateRequestSchema.ts";

export const orderFeedbackCreatePathOrderIdSchema = z.uuid();

export const orderFeedbackCreateStatus201Schema = z.any();

export const orderFeedbackCreateStatus400Schema = errorResponseSchema;

export const orderFeedbackCreateResponseSchema = z.union([orderFeedbackCreateStatus201Schema, orderFeedbackCreateStatus400Schema]);

export const orderFeedbackCreateDataSchemaJson = orderReviewCreateRequestSchema.describe("Входные данные отзыва о заказе из UI.");

export const orderFeedbackCreateDataSchemaXml = orderReviewCreateRequestSchema.describe("Входные данные отзыва о заказе из UI.");

export const orderFeedbackCreateDataSchema = z.union([orderFeedbackCreateDataSchemaJson, orderFeedbackCreateDataSchemaXml]);
